import React from 'react';
import { motion } from 'framer-motion';
import MessageItem from './MessageItem';
import { images } from '../../constants';

const MessageList = ({ 
  messages, 
  isTyping, 
  isInitializing, 
  userInfo, 
  messagesEndRef 
}) => {
  return (
    <div className="app__ask-ai-messages">
      {isInitializing && (
        <motion.div
          className="app__ask-ai-message ai"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.3 }}
        >
          <img src={images.faceLogo} alt="Lovish" style={{ width: '40px', objectFit: 'cover' }} />
          <div className="message-content">
            <div className="typing-indicator">
              <span></span>
              <span></span>
              <span></span>
            </div>
          </div>
        </motion.div>
      )}

      {messages.map((message) => (
        <MessageItem 
          key={message.id} 
          message={message} 
          userInfo={userInfo} 
        />
      ))}
      
      {isTyping && !messages.some(m => m.isStreaming) && (
        <motion.div
          className="app__ask-ai-message ai typing"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.3 }}
        >
          <img src={images.faceLogo} alt="Lovish" style={{ width: '40px', objectFit: 'cover' }} />
          <div className="message-content">
            <div className="typing-indicator">
              <span></span>
              <span></span>
              <span></span>
            </div>
          </div>
        </motion.div>
      )}
      <div ref={messagesEndRef} />
    </div>
  );
};

export default MessageList; 